import { render, staticRenderFns } from "./PersonnelRelated.vue?vue&type=template&id=798e0a36&scoped=true"
import script from "./PersonnelRelated.vue?vue&type=script&lang=js"
export * from "./PersonnelRelated.vue?vue&type=script&lang=js"
import style0 from "./PersonnelRelated.vue?vue&type=style&index=0&id=798e0a36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e0a36",
  null
  
)

export default component.exports